// Resolve image URLs that may be relative (uploaded via admin) or absolute (external).
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function resolveImg(src) {
  if (!src) return '';
  if (src.startsWith('/api/') || src.startsWith('/uploads/')) {
    return `${BACKEND_URL}${src}`;
  }
  return src;
}
